// Phase orders-export · seller order download helpers.
// The backend already returns pre-shaped JSON rows for both templates, so
// this module only handles workbook serialisation and the file-save dance.
import * as XLSX from 'xlsx';
import { toast } from 'sonner';
import api from '@/lib/api';

const buildParams = ({ filters, ids, template }) => {
  const p = {};
  if (filters?.status)     p.status    = filters.status;
  if (filters?.dateFrom)   p.date_from = filters.dateFrom;
  if (filters?.dateTo)     p.date_to   = filters.dateTo;
  if (filters?.q)          p.q         = filters.q;
  if (filters?.sort)       p.sort      = filters.sort;
  // STEP OMS-OUTBOUND-UNIFY-3-R2 · scope 를 백엔드로 전달하여 items[] 필터링.
  if (filters?.item_scope) p.item_scope = filters.item_scope;
  if (ids && ids.length)   p.ids       = ids.join(',');
  if (template)            p.template  = template;
  return p;
};

export const fetchExport = async ({ filters, ids, template } = {}) => {
  const r = await api.get('/seller/orders/export', {
    params: buildParams({ filters, ids, template }),
  });
  return r.data;
};

const setColumnWidths = (ws, columns) => {
  if (!ws['!cols']) ws['!cols'] = [];
  columns.forEach((c, i) => {
    ws['!cols'][i] = { wch: Math.min(40, Math.max(10, String(c).length + 4)) };
  });
};

// Save an `{rows, columns, filename_stem}` payload as .xlsx.
export const saveAsXlsx = (payload) => {
  const { rows, columns, filename_stem } = payload;
  if (!rows || rows.length === 0) { toast.error('다운로드할 주문이 없습니다.'); return; }
  const ws = XLSX.utils.json_to_sheet(rows, { header: columns });
  setColumnWidths(ws, columns);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, '주문');
  XLSX.writeFile(wb, `${filename_stem}.xlsx`);
};

// Save the same payload as CSV (UTF-8 with BOM so Excel opens Korean cleanly).
export const saveAsCsv = (payload) => {
  const { rows, columns, filename_stem } = payload;
  if (!rows || rows.length === 0) { toast.error('다운로드할 주문이 없습니다.'); return; }
  const csv = XLSX.utils.sheet_to_csv(XLSX.utils.json_to_sheet(rows, { header: columns }));
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = `${filename_stem}.csv`;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};

// One-call convenience for the seller UI. Announces truncation to the seller
// so they know the file capped at EXPORT_ROW_LIMIT rows and can narrow the
// filter before re-downloading.
export const downloadOrders = async ({ format = 'xlsx', filters, ids, template } = {}) => {
  try {
    const data = await fetchExport({ filters, ids, template });
    if (data?.truncated) {
      toast.warning(`매칭 ${data.total.toLocaleString('ko-KR')}건 중 상위 ${data.row_count.toLocaleString('ko-KR')}행만 다운로드됩니다. 필터를 좁혀주세요.`);
    }
    (format === 'csv' ? saveAsCsv : saveAsXlsx)(data);
    return data;
  } catch (e) {
    toast.error(e?.response?.data?.detail || '주문 다운로드 실패');
    throw e;
  }
};
